/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

function Template() {
	return (
		<div className='main-container'>
			<section id='confirm-header__section' className='height-60'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-8 align-self-center text-center'>
							<h2 className='big '>Thank You, Marcela!</h2>
							<h3 className=''>
								Woot! Your order has been placed successfully.
							</h3>
							<p>
								We've received your payment and are wrapping up
								your goods to send to you. A confirmation email
								has been sent to the email you've provided.
							</p>
							<a href='/' className='btn'>
								Take me home
							</a>
						</div>
					</div>
				</div>
			</section>

			<Section id='curated__section' className='pt-0'>
				<div className='col-12 text-center'>
					<h2 className=' '>The Curated</h2>
					<h4>
						Thanks for Shopping with The Etho! Check out more
						stylish and ethical clothing at The Curated!
					</h4>
				</div>
				<div className='col-md-6'>
					<div className='curated__image-container' />
				</div>
				<div className='col-md-6'>
					<div className='curated__image-container' />
				</div>
				<div className='col-md-4 hidden-xs'>
					<div className='curated__image-container' />
				</div>
				<div className='col-md-4 hidden-xs'>
					<div className='curated__image-container' />
				</div>
				<div className='col-md-4 hidden-xs'>
					<div className='curated__image-container' />
				</div>
				<div className='col-12 text-center'>
					<a href='/curated' className='btn btn--primary btn--lg'>
						<span className='btn__text'>Go To The Curated</span>
					</a>
				</div>
			</Section>
		</div>
	)
}

export default Template
